import { useQuery } from '@tanstack/react-query';
import { getTemplateAvailability } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const useTemplateAvailabilityQuery = (templateId: string | undefined) => {
	return useQuery({
		queryKey: [API_PATHS.DOCUMENT_TEMPLATES_ID_AVAILABILITY_GET, { id: templateId }],
		queryFn: ({ signal }) => getTemplateAvailability(templateId ?? '', signal),
		enabled: !!templateId,
	});
};
